export const stakerIndexStyle = {
  virtualsGridStyle: {
    padding: '1rem',
    display: 'grid',
    gridTemplateColumns: {
      xs: 'repeat(auto-fit,minmax(230px, 1fr))',
      md: 'repeat(auto-fit,minmax(230px, 300px))',
    },
    gap: '1rem',
  },
  searchBarWrapperStyle: {},
  titleStyle: {
    fontWeight: 700,
    fontSize: '1.5rem',
    marginBottom: '.5rem',
  },
  btnPlaygroundStyle: {
    height: '100%',
    borderRadius: '8px',
  },
  searchVirtualStyle: {
    '& fieldset': {
      border: 0,
    },
  },
  widgetWrapperStyle: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    gap: '1rem',
    '& div': {
      flex: 1,
    },
  },
  selectStartAdornmentStyle: {
    whiteSpace: 'nowrap',
    marginRight: '.5rem',
  },
  infoBoxStyle: {
    borderRadius: 8,
    padding: 1,
  },
  contentStyle: {
    fontWeight: 800,
    fontSize: '1.5rem',
    lineHeight: 1.2,
  },
  infoBoxHeaderStyle: {
    color: '#888',
  },
  infoWrapperStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    border: '1px solid #DDD',
    padding: '1rem',
    marginBottom: '0.5rem',
    flex: 1,
    gap: '1rem',
  },
  yourVirtualRowStyle: {
    padding: '1rem',
    marginY: '1rem',
  },
  validatorRow: {
    display: 'flex',
  },
};
